import type { FaireProductEntity } from "../../entity_types/product";

export const p_32zrh9c8mx: FaireProductEntity = {
  token: "p_32zrh9c8mx",
  type: "product",
  name: "Little Dedi Knitted Blanket Alina 80x100cm - Earth Ivory",
  brandToken: "b_7php3aduqb",
  brandName: "Little Dedi",
  imageUrl:
    "https://cdn.faire.com/fastly/92bf300cbd9fd25fdffeb61f553772c68631ef27191e044eea03cdfb4589248f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1cf8f90e703b6419dc320478215819cca5919d75301b9b89224e6a938a9203c.jpeg",
    "https://cdn.faire.com/fastly/7d73de8b9d49525e8b0b3ecabe0cc40f2d35f6f3c48f6bdd76537fbe3f5fabbc.jpeg",
    "https://cdn.faire.com/fastly/6e719c34a92186eb896d97acf34d514675694205575af4b86597f70406a26975.jpeg",
  ],
  priceDollars: 11.63,
  description:
    "🌿 Natural & Certified Organic\n•\tMaterial: Made from 100% organic cotton, ensuring a soft, breathable, and gentle touch for babies’ delicate skin.\n•\tCertification: Carries the GOTS (Global Organic Textile Standard) certification — a trusted indicator of sustainable, ethically produced textiles from seed to finished product.\n________________________________________\n🧵 Craftsmanship & Comfort\n•\tTexture: Features a double-knit structure combining a plush textured base with a refined border design. This not only enhances durability but also provides cozy warmth without overheating.\n•\tLabel: Includes a soft leatherette Little Dedi label, carefully designed not to irritate or harm baby’s skin.\n________________________________________\n🎁 Gift-Ready Presentation\n•\tPackaging: Comes in a beautifully designed kraft box with botanical illustrations and branding — perfect for gifting at baby showers, birthdays, or as a newborn welcome present.\n________________________________________\n",
  tags: [],
  msrpDollars: 34.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:40.300Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
